import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Img from "@insite/mobius/Img";
import Typography from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { COLORS, TYPOGRAPHY } from "@tCentro/theme/design";
import parse from "html-react-parser";
import React, { FC } from "react";
import { css } from "styled-components";

const enum fields {
    image = "image",
    name = "name",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.image]: string;
        [fields.name]: string;
    };
}

export interface CENSectionNameLogoStyles {
    cardWrapper: InjectableCss;
    logoWrapper: InjectableCss;
    companyName: InjectableCss;
}

export const CENsectionNameLogoStyles: CENSectionNameLogoStyles = {
    cardWrapper: {
        css: css`
            background-color: ${COLORS.background.grayShade};
            padding: 32px;
            margin-bottom: 30px;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            margin-bottom: 0;
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    logoWrapper: {
        css: css`
            display: flex;
            justify-content: center;
        `,
    },
    companyName: {
        css: css`
            margin-top: 48px !important;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            text-align: center;
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
};

const styles = CENsectionNameLogoStyles;

export const CENSectionTemplateNameLogo: FC<OwnProps> = ({ fields }) => {
    return (
        <StyledWrapper {...styles.cardWrapper}>
            <StyledWrapper {...styles.logoWrapper}>
                <Img src={fields.image} altText={fields.name} loading="lazy" />
            </StyledWrapper>
            <Typography variant="h5" {...styles.companyName}>
                {translate("{0}",fields.name)}
            </Typography>
        </StyledWrapper>
    );
};

const CENsectionTemplateNameLogo: WidgetModule = {
    component: CENSectionTemplateNameLogo,
    definition: {
        group: "Basic",
        icon: "image-landscape",
        fieldDefinitions: [
            {
                name: fields.image,
                fieldType: "General",
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                displayName: "Company Image",
            },
            {
                name: fields.name,
                displayName: "Name",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Translatable",
            },
        ],
    },
};

export default CENsectionTemplateNameLogo;
